import React, { useState } from "react";
import { Modal, Button, Form } from "react-bootstrap";
import { toast } from "react-toastify";
import api from "../../api";

// Phase 4C, §13. Reuses the EXISTING project-module-create API
// (POST /form-assignment-options/projects/:projectId/modules, a thin
// passthrough to services/projectModuleService.js's own create()) — no
// duplicate module storage. Server re-validates project access before
// allowing the create, so this can never attach a module to an
// inaccessible project even if the UI were bypassed.
export default function AddProjectModuleDialog({ show, projectId, onClose, onCreated }) {
  const [name, setName] = useState("");
  const [description, setDescription] = useState("");
  const [saving, setSaving] = useState(false);

  const reset = () => {
    setName("");
    setDescription("");
  };

  const handleClose = () => {
    reset();
    onClose();
  };

  const handleCreate = async () => {
    if (!name.trim()) {
      toast.warning("Module name is required");
      return;
    }
    setSaving(true);
    try {
      const res = await api.post(`/form-assignment-options/projects/${projectId}/modules`, { name: name.trim(), description: description.trim() || null });
      toast.success("Module created");
      reset();
      onCreated(res.data?.data);
    } catch (err) {
      toast.error(err.response?.data?.message || "Failed to create module");
    } finally {
      setSaving(false);
    }
  };

  return (
    <Modal show={show} onHide={handleClose} centered>
      <Modal.Header closeButton><Modal.Title>Add Project Module</Modal.Title></Modal.Header>
      <Modal.Body>
        <Form.Label>Module Name</Form.Label>
        <Form.Control value={name} onChange={(e) => setName(e.target.value)} autoFocus />
        <Form.Label className="mt-3">Description (optional)</Form.Label>
        <Form.Control as="textarea" rows={2} value={description} onChange={(e) => setDescription(e.target.value)} />
      </Modal.Body>
      <Modal.Footer>
        <Button className="unit-btn unit-btn-light" onClick={handleClose}>Cancel</Button>
        <Button className="unit-btn unit-btn-primary" onClick={handleCreate} disabled={saving}>
          {saving ? "Creating..." : "Create Module"}
        </Button>
      </Modal.Footer>
    </Modal>
  );
}
